module.exports = __webpack_public_path__ + "static/media/Slide2.dc9f4eba.jpg";